<template>
  <div></div>
</template>
<!-- <script lang="ts" setup>
/* eslint-disable no-undef */
import { onMounted, ref } from "vue";
import { DialogHandler } from "./DialogHandler";
import CoreDialog from "@/framework/components/dialog/CoreDialog.vue";
import { Loader } from "@googlemaps/js-api-loader";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { addGPSAttributeBlockToWorkSpace } from "../../blockly/custom/addWorkspace";
import { useRoute } from "vue-router";
import { BlockFactory } from "../../blockly/BlockFactory";
//https://blog.rhyztech.net/googlemaps_with_typescript/
const dialogId = DialogHandler.gpsSelectDialogId;

const project_id = useRoute().params.project_id as string;

const title = "GPS Select Dialog";
const loader = new Loader({
  apiKey: "AIzaSyB9D412riHCmBqpyiNRTMCZWfTcK1EUyHM",
  version: "weekly",
});

loader.load().then(() => {
  const geocoder = new google.maps.Geocoder();

  geocoder.geocode({ address: "東京都千代田区" }, (results, status) => {
    if (status == "OK" && results![0].geometry?.location !== undefined) {
      console.log(results![0].geometry?.location);
    }
  });
});

function initMap() {
  navigator.geolocation.getCurrentPosition((pos) => {
    const myLatlng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 20,
      center: myLatlng,
    });

    /**
     * mapをクリックした時
     */
    map.addListener("click", (e) => {
      const latlng = e.latLng;
      console.log(latlng);
      const marker = addMarker(latlng, `${latlng.latitude},${latlng.longitude}`, map);
      map.panTo(marker.getPosition());

      /**
       * マーカーをクリックした時
       */
      marker.addListener("click", function () {
        map.setZoom(50);
        const pos = marker.getPosition();
        map.setCenter(pos);
        const factory = new BlockFactory();
        const xml = factory.getGPSAttribute(pos.lat(), pos.lng());
        factory.addWorkspace(xml);

        MessageDialog.info(`lat:${pos.lat()},lng:${pos.lng()}`);
        DialogHandler.hideDialog(DialogHandler.gpsSelectDialogId);
      });
    });
  });
}

// const search_map = (e) => {
//   console.log('search', e);
//   var place = document.getElementById('search_map_word').value;
//   var geocoder = new google.maps.Geocoder();
//   geocoder.geocode({ address: place }, function (results, status) {
//     if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
//       alert('見つかりません');
//       console.log(status);
//       return;
//     }
//     if (status !== google.maps.GeocoderStatus.OK) {
//       alert('エラー');
//       console.log(status);
//       return;
//     }

//     var bounds = new google.maps.LatLngBounds();
//     for (var i in results) {
//       console.log(results[i]);
//       if (!results[i].geometry) {
//         continue;
//       }
//       let latlng = results[i].geometry.location;
//       let address = results[i].formatted_address;

//       addMarker(latlng, address, self.map);
//       self.map.panTo(marker.getPosition());

//       // 検索結果地が含まれるように範囲を拡大
//       // bounds.extend(latlng);
//       // console.log(address)

//       // マーカーへの吹き出しの追加
//       // setInfoW(place, latlng, address);
//       // マーカーにクリックイベントを追加
//       // markerEvent();
//     }
//   });
// };

function addMarker(place, title, map) {
  const iconUrl = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
  const marker = new google.maps.Marker({
    position: place,
    map: map,
    animation: google.maps.Animation.DROP,
    title: title,
    icon: iconUrl,
  });
  return marker;
}

// マーカーへの吹き出しの追加
function setInfoW(place, latlng, address) {
  const infoWindow = new google.maps.InfoWindow({
    content:
      "<a href='http://www.google.com/search?q=" +
      place +
      "' target='_blank'>" +
      place +
      "</a><br><br>" +
      latlng +
      "<br><br>" +
      address +
      "<br><br><a href='http://www.google.com/search?q=" +
      place +
      "&tbm=isch' target='_blank'>画像検索 by google</a>",
  });
}

onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, (e: Event) => {
    initMap();
  });
});
</script>
<template>
  <core-dialog :id="dialogId" :dialog-class="{ 'modal-xl': true }" :title="title">
    <div>
      {{ dialogId }}
      <div id="map" style="height: 30rem" class="w-100"></div>
    </div>
  </core-dialog>
</template> -->
